import type { CustomerStatus } from '@optiflow/types';
import { StatusBadge } from '@/components/ui/StatusBadge';

/** Thin wrapper so customer screens do not each decide how a status looks. */
export function CustomerStatusBadge({ status }: { status: CustomerStatus }) {
  return <StatusBadge status={status} />;
}
